import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledCell = /*#__PURE__*/styled.td.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1ljfili-0"
})(["background:", ";color:", ";font:", ";padding:", ";border-top:", ";border-bottom:", ";text-align:start;vertical-align:top;", ""], ({
  theme
}) => theme.surface.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.table.cell.border.body.default, ({
  theme
}) => theme.table.cell.border.body.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
const ValueCell = ({
  children,
  ...rest
}) => /*#__PURE__*/React__default.createElement(StyledCell, _extends({
  role: "cell"
}, rest), children);

export { ValueCell as V };
//# sourceMappingURL=ValueCell-CpuCHIow.js.map
